import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-welltect-forgot-password',
  templateUrl: './welltect-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './welltect-forgot-password.component.css',
  ],
})
export class WelltectForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
